<template>
  <transition @enter="onStartLoading" @leave="onLoaded" @after-leave="aniEnded">
    <div v-if="show" class="opening-animation-container" ref="mainbody">
      <div class="opening-main-container">
        <div class="loading-logo"></div>
        <div class="loading-bar"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'c__home-opening',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: this.loading,
    };
  },
  watch: {
    loading(val) {
      this.show = val;
    },
  },
  mounted() {
    if (this.$store.state.firstEnterWebSite) {
      this.$refs.mainbody.classList.add('home-loading');
    }
  },
  methods: {
    onStartLoading(e, done) {
      console.log(e);
      done();
    },
    onLoaded(e, done) {
      e.classList.remove('home-loading');
      e.classList.add('--finish');
      const p = new Promise((resolve) => {
        // 具体时间可选
        setTimeout(() => {
          resolve();
        }, 1000);
      });
      p.then(() => {
        done();
      });
    },
    aniEnded() {
      this.$emit('openAniFinish');
    },
  },
};
</script>

<style></style>
